export const leadership = {
  directors: [
    {
      id: 1,
      name: "Rajesh Tanavi",
      position: "Managing Director & CEO",
      experience: "25+ Years",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=500",
      bio: "Visionary leader with over 25 years of experience in real estate development. Under his leadership, Tanavi Properties has delivered 50+ successful projects across Hyderabad."
    },
    {
      id: 2,
      name: "Priya Tanavi",
      position: "Director - Operations",
      experience: "20+ Years",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=500",
      bio: "Expert in project management and operations with a proven track record of delivering projects on time. Specializes in quality control and customer satisfaction."
    },
    {
      id: 3,
      name: "Anil Kumar Reddy",
      position: "Director - Finance",
      experience: "22+ Years",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=500",
      bio: "Financial strategist with extensive experience in real estate finance and investment planning. Ensures financial stability and growth of the organization."
    }
  ],
  boardMembers: [
    {
      id: 1,
      name: "Dr. Srinivas Rao",
      position: "Independent Director",
      image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=500",
      bio: "Former IAS officer with expertise in urban planning and development."
    },
    {
      id: 2,
      name: "Lakshmi Devi",
      position: "Board Member",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=500",
      bio: "Legal expert specializing in real estate law and regulatory compliance."
    },
    {
      id: 3,
      name: "Venkat Ramana",
      position: "Board Member",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=500",
      bio: "Architect and urban designer with 30+ years of experience."
    },
    {
      id: 4,
      name: "Kavitha Sharma",
      position: "Board Member",
      image: "https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=500",
      bio: "Marketing strategist with expertise in real estate branding."
    }
  ]
};
